import { apiClient, assertOk } from "@/api/generated/client.ts"
import type { DataPointIntervalRequest, DataPointValue } from "@/types/dataPointTypes.ts"

export const getDataPointIntervals = async (
  id: number,
  req: DataPointIntervalRequest,
): Promise<DataPointValue[]> => {
  const { data, error, response } = await apiClient.GET("/api/DataPoints/{id}/intervals", {
    params: {
      path: { id },
      query: {
        Start: req.start.toISOString(),
        End: req.end.toISOString(),
        Interval: req.interval,
        AggMode: req.aggMode,
        PageSize: req.pageSize,
        Page: req.page,
      },
    },
  })
  return assertOk(response, error, data)
}
